import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";

@Pipe({
  name: "date",
})
export class DatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    value: string | moment.Moment,
    args: { format: string } = { format: "DD-MM-YYYY H:mm:ss" },
  ): any {
    return moment(value)
      .locale(this.translateService.currentLang)
      .format(args.format);
  }
}
